import React from "react";
import { Box, Collapse, createStyles, Theme, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { getLocalizedValue } from "../../core/lang";
import CustomIcon from "../../core/custom-icon";
import { useIntl } from "react-intl";
import { LocalizedString } from "../../generated/platform";
import { Locale } from "../../core/api/model";

export interface Props {
  locale: Locale;
  productName: LocalizedString;
  productDescription: LocalizedString;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    toggleTitle: {
      cursor: 'pointer'
    }
  }),
);

export const MeetingProductAccordion = ({
  productName,
  productDescription,
  locale
}: Props) => {
  const [isOpen, setIsOpen] = React.useState<boolean>(false);
  const { formatMessage } = useIntl();
  const classes = useStyles();

  const onToggle = () => {
    setIsOpen(!isOpen);
  }

  return (
    <Box>
      <Box display='flex'
           alignItems='center'
           component='div'
           color='primary.main'
           className={classes.toggleTitle}
           onClick={onToggle}>
        <Box component='span' fontStyle='h4.fontStyle' mr={1}>
          <Typography component='h3' variant='h4'>
            {formatMessage({
              id: "MeetingLobbyProductAccordionTitle",
              defaultMessage: "Gewähltes Produkt",
            })}
          </Typography>
        </Box>
        <CustomIcon iconname={isOpen ? 'arrowUp' : 'arrowDown'} fontSize='default'/>
      </Box>
      <Collapse in={isOpen}>
      <Box pt={2}>
        <Typography component="h3" variant="h4" color="primary" gutterBottom>
          {getLocalizedValue(locale, productName)}
        </Typography>
        <Box mt={2}>
          <Typography variant='body1' color='primary'>
            {getLocalizedValue(locale, productDescription)}
          </Typography>
        </Box>

      </Box>
      </Collapse>
    </Box>
  )
};
